module.exports = __webpack_public_path__ + "img/1529006138.9685b866.jpg";